import AppliedRoute from './AppliedRoute';
import AuthenticatedRoute from './AuthenticatedRoute';
import UnauthenticatedRoute from './UnauthenticatedRoute';

export default { AppliedRoute, AuthenticatedRoute, UnauthenticatedRoute };
